import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import useGetLastRunForInspection from './hooks/useGetLastIIMRun';
import useUpdateIIMRunPublished from './hooks/useUpdateIIMRunPublished';
function PublishInspectionManagerRunButtonContent({ inspectionId }) {
    var _a;
    const { data: lastRun, isLoading } = useGetLastRunForInspection(inspectionId);
    const { mutate: updatePublished } = useUpdateIIMRunPublished({
        inspectionId,
        iimRunId: (_a = lastRun === null || lastRun === void 0 ? void 0 : lastRun.id) !== null && _a !== void 0 ? _a : 0
    });
    const handleButtonClick = () => {
        updatePublished({ published: !(lastRun === null || lastRun === void 0 ? void 0 : lastRun.published) });
    };
    if (isLoading || !lastRun) {
        return null;
    }
    return (React.createElement("button", { type: "button", className: "qmb-control--tertiary", onClick: handleButtonClick }, (lastRun === null || lastRun === void 0 ? void 0 : lastRun.published) ? 'Unpublish' : 'Publish'));
}
function PublishInspectionManagerRunButton({ inspectionId }) {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(PublishInspectionManagerRunButtonContent, { inspectionId: Number(inspectionId) })));
}
export default PublishInspectionManagerRunButton;
